export const GET_SUPPORT_TABLES = 'GET_SUPPORT_TABLES'
export const GET_SUPPORT_TABLE = 'GET_SUPPORT_TABLE'
export const POST_SUPPORT_TABLE = 'POST_SUPPORT_TABLE'
export const PATCH_SUPPORT_TABLE = 'PATCH_SUPPORT_TABLE'
export const RESET_SUPPORT_TABLE = 'RESET_SUPPORT_TABLE'
export const DELETE_SUPPORT_TABLE = 'DELETE_SUPPORT_TABLE'
export const GET_SUPPORT_TYPE = 'GET_SUPPORT_TYPE'
